export interface SellerFormData {
  id?: string | number;
  name: string;
  designation?: string;
  email: string;
  phone: string;
  address: string;
  organization: string;
  username?: string;
  password?: string;
  confirmPassword?: string;
  photo?: string;
  referenceId?: string | number;
  countryCode?: string;
  roles?: string[];
}

export interface SellerInfo {
  id: number;
  sellerId?: string;
  name: string;
  designation?: string;
  email: string;
  phone: string;
  address: string;
  organization: string;
  photo?: string;
  tokenBalance?: number;
  referenceId?: number;
  createdAt?: string;
  updatedAt?: string;
  twoFactorEnabled?: boolean;
  username?: string;
  uninstallConfirmationRequired?: boolean;
  duePaymentNotificationEnabled?: boolean;
  totalDue?: number;
}

export type RetailerInfo = SellerInfo;

export interface SellerBasicInfo {
  id: number | string;
  name: string;
  phone: string;
  designation?: string;
  sellerId?: string;
}

export interface SellerTokenRequest {
  sellerId: number;
  numberOfTokens: number;
}

export enum SellerDesignation {
  DISTRIBUTOR = "DISTRIBUTOR",
  DEALER = "DEALER",
  RETAILER = "RETAILER",
}

export interface SellerDashboardInfo {
  tokenBalance: number;
  totalDevices: number;
  lockedDevices: number;
  todayActivation: number;
  purchaseCurrentMonth: number;
  deviceRegistrationCurrentMonth: number;
  totalPurchase: number;
}

export interface SellerSalesReportInfo {
  sellerName: string;
  phone: string;
  tokenBalance: number;
  purchaseCurrentMonth: number;
  deviceRegistrationCurrentMonth: number;
  totalPurchase: number;
  totalDevices: number;
}